import APICall from "../APICall";
import { stringifyFilter } from "../utils/helperFunc";

const AddsourcetoPlan = async (payload) => {
  const res = await APICall("savings/addsourcetoplan", "POST", payload);
  return res;
};

const createSavingPlan = async (payload) => {
  const { data } = await APICall("savings/addplan", "POST", payload);
  return data;
};

const getPlanDetails = async (planId) => {
  const res = await APICall(`savings/getplandetails?planId=${planId}`, "GET");
  return res;
};

const getSavingsPlans = async (status) => {
  const res = await APICall(`savings/listplanbystatus?status=${status}`, "GET");
  return res?.data;
};

const validatePayment = async (payload) => {
  const res = await APICall(`card/validatepayment`, "POST", payload);
  return res;
};

const editSavingPlans = async (planID, payload) => {
  const res = await APICall(`savings/${planID}`, "PUT", payload);
  return res;
};

const createLockedSavings = async (payload) => {
  const res = await APICall("savings/create-locked", "POST", payload);
  return res;
};

const withdrawPlan = async (payload) => {
  const res = await APICall("savings/withdraw", "POST", payload);
  return res;
};

const getCliqDetails = async (groupId) => {
  const res = await APICall(`savings/get-cliq?code=${groupId}`, "GET");
  return res;
};

const joinCliqSavings = async (payload) => {
  const res = await APICall("savings/join-cliq", "POST", payload);
  return res;
};

const initiateCardPayment = async (payload) => {
  const res = await APICall("card/initiatepayment", "POST", payload);
  return res;
};

const getCliqSavings = async () => {
  const res = await APICall(`savings/my-cliq-plans`, "GET");
  return res;
};

const getPublicCliqSummary = async (payload) => {
  const res = await APICall(`savings/public-cliq-summary`, "POST", payload);
  return res;
};

const createCliqSavings = async (payload) => {
  const cliqFormData = new FormData();
  cliqFormData.append("name", payload.name);
  cliqFormData.append("description", payload.description);
  cliqFormData.append("frequency", payload?.frequency);
  cliqFormData.append("duration", payload.duration);
  cliqFormData.append("enableInterest", payload.enableInterest);
  cliqFormData.append("startDate", payload.startDate);
  cliqFormData.append("autoSave", payload.autoSave);
  cliqFormData.append("amount", payload.amount);
  cliqFormData.append("cardId", payload.cardId);
  cliqFormData.append("total_member_count", payload.total_member_count);
  payload?.image && cliqFormData.append("image", payload.image);

  const res = await APICall("savings/create-cliq", "POST", payload, true);
  return res;
};

const createPublicCliq = async (payload) => {
  const cliqFormData = new FormData();
  cliqFormData.append("name", payload.name);
  cliqFormData.append("description", payload.description);
  cliqFormData.append("frequency", payload?.frequency);
  cliqFormData.append("duration", payload.duration);
  cliqFormData.append("startDate", payload.startDate);
  cliqFormData.append("amount", payload.amount);
  cliqFormData.append("cardId", payload.cardId);
  cliqFormData.append("planSource", payload.planSource);
  cliqFormData.append("member_target_amount", payload.member_target_amount);
  cliqFormData.append("saving_amount", payload.saving_amount);
  payload?.image && cliqFormData.append("image", payload.image);

  const res = await APICall(
    "savings/create-public-cliq",
    "POST",
    payload,
    true
  );
  return res;
};

const cliqSummary = async (payload) => {
  const res = await APICall("savings/cliq-summary", "POST", payload);
  return res;
};

const topUpPlan = async (payload) => {
  const res = await APICall("savings/topupplan", "POST", payload);
  return res;
};

const lockedSummary = async (payload) => {
  const res = await APICall("savings/locked-summary", "POST", payload);
  return res;
};

const getSavingsPlanByStatus = async (status) => {
  const res = await APICall(`savings/listplanbystatus?status=${status}`, "GET");
  return res;
};

const pauseSavingsPlan = async (savingsId) => {
  const res = await APICall(`savings/${savingsId}/pause`, "PATCH");
  return res;
};

const getPublicCliqs = async (query) => {
  const filters = stringifyFilter(query);
  const res = await APICall(`savings/public-cliqs${filters}`, "GET");
  return res;
};

const joinPublicCliq = async (payload) => {
  const res = await APICall(`savings/join-public-cliq`, "POST", payload);
  return res;
};

const getCliqActiities = async (cliqId) => {
  const res = await APICall(`savings/cliq-activities/${cliqId}`, "GET");
  return res;
};

const savingService = {
  createSavingPlan,
  getSavingsPlans,
  AddsourcetoPlan,
  validatePayment,
  editSavingPlans,
  createLockedSavings,
  withdrawPlan,
  getCliqDetails,
  joinCliqSavings,
  initiateCardPayment,
  getCliqSavings,
  createCliqSavings,
  getPlanDetails,
  cliqSummary,
  topUpPlan,
  lockedSummary,
  getSavingsPlanByStatus,
  pauseSavingsPlan,
  getPublicCliqs,
  joinPublicCliq,
  getCliqActiities,
  createPublicCliq,
  getPublicCliqSummary,
};

export default savingService;
